<div class="MainContainer animated fadeIn" *ngIf="!this.parent.loading">

  <div class="overlay" *ngIf="ShowCombinePartnerSecurityCheckErrorQuestion || ShowStockFormatContainer || ShowAutomatedTasksConnections || ShowCombinePartners || ShowPartnerSheet || ShowPrePartnerSheet || showAddNewPartnerPopUp || showEditPartnerPopUp"></div>

  <div *ngIf="ShowAutomatedTasksConnections" class="AutomatedTasksConnections" style="height:60vh;">
    <div class="PopUpCloseContainer" (click)="ShowAutomatedTasksConnections = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
      <p>{{ 'AutomatedTasksConnections' | translate }}</p>
    </div>
    <div class="PopUpBody" style="margin-bottom: 0px;">
      <div class="AutomatedTask" *ngFor="let a of this.AutomatedTasksConnections">
      <p class="AutomatedTasksTitle">
        <span>{{a.AutomatedTask.Description}}</span>
        <mat-slide-toggle [(ngModel)]="a.Active" style="float: right;margin-top: 10px;margin-right: 15px;">{{'ActiveJob' | translate}}</mat-slide-toggle>
      </p>
      <p class="LastRun">{{'LastRun' | translate}}: {{a.AutomatedTask.LastRunUI}}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Frequency' | translate }}</mat-label>
          <mat-select [(ngModel)]="a.Frequency" name="Frequency" [compareWith]="compareFn">
            <mat-option *ngFor="let f of Frequencies" [value]="f">
              {{f.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      <div class="ATPartnerAgents">
        <div class="ATPartner" *ngFor="let agent of a.PartnerAgents" (click)="AddOrDeletePartnerAgentFromTaskConnection(agent.ID, a.AutomatedTask.ID, agent.IsSelected); agent.IsSelected = !agent.IsSelected;">
          <span>{{agent.Name}}({{agent.Email}}/{{agent.Department?.Name}})</span>
          <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: red;">close</i>
          <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #0082e6;">check</i>
        </div>
      </div>
      <p class="AutomatedTaskDetailDescription">{{a.AutomatedTask.DetailDescription}}</p>
      </div>
    </div>
    <div class="PopUpCommands">
      <button mat-raised-button color="primary" class="AutomatedTasksConnectionsUpdateButton" (click)="UpdateAutomatedTaskConnections();">{{'UpdateConections' | translate}}</button>
    </div>
  </div>

  <div style="z-index: 1000;" *ngIf="ShowCombinePartnerSecurityCheckErrorQuestion" class="StockFormatContainer">
    <div class="PopUpCloseContainer" (click)="ShowCombinePartnerSecurityCheckErrorQuestion = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
      <p>{{ 'ShowCombinePartnerSecurityCheckErrorQuestionTitle' | translate }}</p>
    </div>
    <div class="PopUpBody" style="margin-bottom: 0px;">
         {{ShowCombinePartnerSecurityCheckErrorQuestionMessage}}
    </div>
    <div class="PopUpCommands">
      <button mat-raised-button color="primary" class="AutomatedTasksConnectionsUpdateButton" (click)="CombinePartners(this.SelectedPartners, this.TargetPartner, false);">{{'CombineAnyway' | translate}}</button>
      <button mat-raised-button class="AutomatedTasksConnectionsUpdateButton" (click)="ShowCombinePartnerSecurityCheckErrorQuestion = false;">{{'Back' | translate}}</button>
    </div>
  </div>

  <div *ngIf="ShowStockFormatContainer" class="StockFormatContainer">
    <div class="PopUpCloseContainer" (click)="ShowStockFormatContainer = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
      <p>{{ 'PrefferedStockFormat' | translate }}</p>
    </div>
    <div class="PopUpBody" style="margin-bottom: 0px;">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>{{ 'PrefferedStockFormat' | translate }}</mat-label>
          <mat-select [(ngModel)]="currentPartner.PrefferedStockFormat" name="PrefferedStockFormat" [compareWith]="compareFn">
            <mat-option *ngFor="let f of PrefferedStockFormats" [value]="f">
              {{f.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <div class="PopUpCommands">
      <button mat-raised-button color="primary" class="AutomatedTasksConnectionsUpdateButton" (click)="AddUpdatePartnerPrefferedStockFormat(currentPartner?.ID, currentPartner?.PrefferedStockFormat?.ID);">{{'UpdateStockFormat' | translate}}</button>
    </div>
  </div>

  <div class="PrePartnerSheetPopUp animated fadeInDown" *ngIf="ShowCombinePartners;">
    <div class="PopUpCloseContainer" (click)="ShowCombinePartners = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
      <p>{{ 'CombinePartners' | translate }}</p>
    </div>

    <div class="PopUpBody">
      <div class="MainTitleBar" style="overflow: hidden;">

        <div class="MainTitleBarIconContainer">
          <i class="material-icons">merge</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'SelectTargetPartner' | translate }}</mat-label>
            <mat-select name="DecimalPrecision" [compareWith]="compareFn" [(ngModel)]="TargetPartner">
              <mat-option *ngFor="let p of this.SelectedPartners" [value]="p">
                {{p.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="PopUpCommands">
      <button
        [disabled]="!TargetPartner" mat-raised-button color="primary" matTooltip="{{'CombinePartners' | translate}}"
        class="PopGeneralCommandButton" (click)="CombinePartners(this.SelectedPartners, this.TargetPartner, true);">{{'CombinePartners' | translate}}
      </button>
    </div>
  </div>

  <div *ngIf="ShowPartnerSheet" class="animated fadeInDown NewPartnerPopUp" style="top: 10%;max-height: 600px;">
    <div class="PopUpCloseContainer" (click)="ShowPartnerSheet = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpCommands" style="padding-left: 2.5%;padding-top: 10px;">

      <button [disabled]="loadingExport" mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;" (click)="ExportPartnerSheet(false);">
        <i class="material-icons">file_copy</i>
        <span>{{ 'Receptions.Document.Export' | translate }}</span>
      </button>
  
      <button [disabled]="loadingExport" mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="ExportPartnerSheet(true);">
        <i class="material-icons">print</i>
        <span>{{ 'Receptions.Document.Print' | translate }}</span>
      </button>

      <mat-progress-bar mode="query" *ngIf="loadingExport" class="PartnerSheetProgressBar"></mat-progress-bar>
    </div>

    <div class="PopUpTitleContainer" style="height: auto;">
      <div class="PartnerSheetTitle">
        {{PartnerSheet.Company.Name}}
      </div>
      <div class="PartnerSheetSubTitle">
        {{PartnerSheet.Company.Addresses[0]?.StateProvince}}, {{PartnerSheet.Company.Addresses[0]?.City}},
        {{PartnerSheet.Company.Addresses[0]?.AddressLine}}
      </div>
      <div class="PartnerSheetTitle">
        {{'AccountSheet' | translate}}
      </div>

      <div class="PartnerSheetSubTitle">
        <span style="float: left;">{{'Period' | translate}}: {{PartnerSheet.FromDate}} - {{PartnerSheet.ToDate}}</span>
        <span style="float: right;margin-right: 3.5%;">{{'Currency' | translate}}: {{PartnerSheet.Currency.Name}}</span>
      </div>

    </div>

    <div class="PopUpBodyPartnerSheet" style="max-height: 300px;">

      <div class="PartnerSheetRow PartnerSheetHeadder">
        <div class="PartnerSheetCol" style="width: 5%;">
          {{'Receptions.Table.Nr' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          {{'Date' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          {{'DocType' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          {{'DocumentNumber' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          {{'Obersvations' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          {{'Debit' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          {{'Credit' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          {{'FinalBalance' | translate}}
        </div>
        <div class="PartnerSheetCol" style="width: 5%;">
          D/C
        </div>
      </div>

      <div class="PartnerSheetRow" *ngFor="let row of this.PartnerSheet.ContentRows; let i = index;">
        <div [ngClass]="{'OpeningClosingBalance': row.Type.ID <= -1}">
          <div class="PartnerSheetCol" style="width: 5%;text-align: center;">
            {{i + 1}}
          </div>
          <div class="PartnerSheetCol" style="width: 10%;">
            {{row.UIRow.DateUI}}
          </div>
          <div class="PartnerSheetCol" style="width: 10%;">
            {{row.UIRow.Type}}
          </div>
          <div class="PartnerSheetCol" style="width: 15%;">
            {{row.UIRow.DisplayValue}}
          </div>
          <div class="PartnerSheetCol" style="width: 10%;">
            {{row.UIRow.Obersvations}}
          </div>
          <div class="PartnerSheetCol" style="width: 15%;">
            <span
              *ngIf="row.UIRow.Debit != null;">{{row.UIRow.Debit.UITotalQtyPriceVAT.Integer}}{{row.UIRow.Debit.UITotalQtyPriceVAT.Decimals}}</span>
          </div>
          <div class="PartnerSheetCol" style="width: 15%;">
            <span
              *ngIf="row.UIRow.Credit != null;">{{row.UIRow.Credit.UITotalQtyPriceVAT.Integer}}{{row.UIRow.Credit.UITotalQtyPriceVAT.Decimals}}</span>
          </div>
          <div class="PartnerSheetCol" style="width: 15%;">
            <span>{{row.UIRow.Final.UITotalQtyPriceVAT.Integer}}{{row.UIRow.Final.UITotalQtyPriceVAT.Decimals}}</span>
          </div>
          <div class="PartnerSheetCol" style="width: 5%;">
            {{row.UIRow.GeneralTypeUI}}
          </div>
        </div>
      </div>

    </div>

    <div class="PartnerSheetTotals">
      <div class="PartnerSheetRow" *ngFor="let row of this.PartnerSheet.Totals; let i = index" style="border: none;">
        <div class="PartnerSheetCol" style="width: 5%;">
          
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          
        </div>
        <div class="PartnerSheetCol" style="width: 10%;">
          
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
         
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          Total {{row.DocumentDisplayValue}}
        </div>
        <div class="PartnerSheetCol" style="width: 15%;">
          {{row.Total.UITotalQtyPriceVAT.Integer}}{{row.Total.UITotalQtyPriceVAT.Decimals}}
        </div>
        <div class="PartnerSheetCol" style="width: 5%;">
          
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showAddNewPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
    <div class="PopUpCloseContainer" (click)="showAddNewPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
     <p>{{ 'Partners.AddNewPartner' | translate }}</p>
    </div>

    <div class="PopUpBody">

      <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

      <form [formGroup]="newPartner">
        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
          <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
          <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.newPartner, true);" *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">cloud_download</i>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
          <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
        </mat-form-field>

        <div class="PopUpBodySemiTextBox">
          <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
            <mat-select [(ngModel)]="newPartnerCountry" name="country" formControlName="Country" [compareWith]="compareFn" required>
              <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="City">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'ZipCode' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
        </mat-form-field>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
            <mat-select [(ngModel)]="newPartnerBank" name="bank" formControlName="Bank">
              <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                {{b.Name}} <span *ngIf="b.Swift?.length > 0;">({{b.Swift}})</span> 
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox" *ngIf="newPartnerBank != null;">
          <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
        </mat-form-field>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Currency' | translate }}</mat-label>
            <mat-select name="BankAccountCurrency" [compareWith]="compareFn" formControlName="BankAccountCurrency">
              <mat-option *ngFor="let c of parent.masterData.Currencies" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Email' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
        </mat-form-field>
      </form>

    </div>

    <div class="PopUpCommands">
      <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="AddNewPartner();">{{'Partners.AddNewPartner' | translate}}</button>
    </div>
  </div>

  <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
    <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
     <p>{{ 'Partners.EditPartner' | translate }}</p>
    </div>

    <div class="PopUpBody">

      <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

      <form [formGroup]="currentPartner">
        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
          <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
          <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
          <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
        </mat-form-field>

        <div class="PopUpBodySemiTextBox">
          <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
            <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
              <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'ZipCode' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
        </mat-form-field>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
            <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
              <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                {{b.Name}} <span *ngIf="b.Swift?.length > 0;">({{b.Swift}})</span> 
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
        </mat-form-field>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Currency' | translate }}</mat-label>
            <mat-select name="BankAccountCurrency" [compareWith]="compareFn" formControlName="BankAccountCurrency">
              <mat-option *ngFor="let c of parent.masterData.Currencies" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Email' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
        </mat-form-field>
      </form>

    </div>

    <div class="PopUpCommands">
      <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">{{'UpdatePartner' | translate}}</button>
    </div>
  </div>

  <div class="PrePartnerSheetPopUp animated fadeInDown" *ngIf="ShowPrePartnerSheet;">
    <div class="PopUpCloseContainer" (click)="ShowPrePartnerSheet = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
      <p>{{ 'PartnerSheetSettings' | translate }} - {{this.currentPartner.Name}}</p>
    </div>

    <div class="PopUpBody">

      <div class="PopUpBodyInfoRow">
        <label id="example-radio-group-label">{{'SheetType' | translate}}</label>
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
          [(ngModel)]="SheetType">
          <mat-radio-button class="example-radio-button" *ngFor="let type of this.PartnerSheetTypes" [value]="type">
            {{type.Name}}
          </mat-radio-button>
        </mat-radio-group>
        <div>{{'ChosenSheetType' | translate}}: {{SheetType?.Name}}</div>
      </div>

      <div class="MainTitleBar" style="overflow: hidden;">

        <div class="MainTitleBarIconContainer">
          <i class="material-icons">content_paste_search</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
            <mat-select name="DecimalPrecision" [compareWith]="compareFn" [(ngModel)]="Filter.DecimalPrecision">
              <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p">
                {{p.Meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="MainTitleBar" style="overflow: hidden;">

        <div class="MainTitleBarIconContainer">
          <i class="material-icons">content_paste_search</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'Receptions.Currency' | translate }}</mat-label>
            <mat-select name="Currency" [compareWith]="compareFn" [(ngModel)]="Filter.Currency">
              <mat-option *ngFor="let c of this.Currencies" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a"
                (click)="AddActiveFilter(a.Name, 'Period'); GetCashCollectionsFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate"
              (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>

        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate"
              (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

    </div>

    <div class="PopUpCommands">
      <button *ngIf="this.Filter.Period != null || (Filter.FromDate != null && Filter.ToDate != null);"
        [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{'GetPartnerSheet' | translate}}"
        class="PopGeneralCommandButton" (click)="GeneratePartnerSheet();">{{'GetPartnerSheet' | translate}}</button>
      <button *ngIf="this.Filter.Period == null && (Filter.FromDate == null || Filter.ToDate == null);"
        [disabled]="true" mat-raised-button color="primary" matTooltip="{{'GetPartnerSheet' | translate}}"
        class="PopGeneralCommandButton">{{'GetPartnerSheet' | translate}}</button>
    </div>
  </div>

  <div class="MainTitleBar" style="width: 100%;margin-left: 0%;margin-right: 0%;">

    <mat-form-field class="example-form-field TitleBarSearchInput" appearance="outline">
      <mat-label>{{ 'Partners.SearchPartners' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="this.searchTerm"
        (change)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" autocomplete="off">
      <mat-icon class="searchTermButton" *ngIf="!this.searchTerm" style="font-size: 20px;color: #0082e6;"
        (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);">search</mat-icon>
      <mat-icon class="searchTermButton" style="font-size: 20px;color: #0082e6;" *ngIf="this.searchTerm"
        (click)="this.searchTerm=''; GetPartnersFiltered(this.searchTerm, this.countryID, true);">close</mat-icon>
    </mat-form-field>

    <button mat-raised-button color="primary" matTooltip="{{ 'Partners.AddNewPartner' | translate }}"
      class="TopRightButton" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">
      <i class="material-icons">person_add_alt_1</i>
      {{ 'Partners.AddNewPartner' | translate }}
    </button>
  </div>

  <div class="tableContainer" *ngIf="Partners?.length">
    <table mat-table [dataSource]="Partners" class="mat-elevation-z8 PartnersTable">

      <!-- Position Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.Name' | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox class="example-margin" style="float: left;margin-right: 10px;" [(ngModel)]="element.IsSelected"></mat-checkbox>
          <span>{{element.Name}}</span>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="VAT">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.VAT' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.VAT}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="UPN">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.UPN' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.UPN}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="COCRegNumber">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.COCRegNumber' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.COCRegNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="ContactName">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.ContactName' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.ContactInfo.Name}} </td>
      </ng-container>

      <ng-container matColumnDef="Registered">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.Registered' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.RegisteredUI}} </td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef> {{ 'Partners.Actions' | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <i class="material-icons actionsArrow" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="initializePartnerFormFromObject(element);">
              <i class="material-icons menuitemIcon">mode_edit</i>
              {{ 'Partners.Edit' | translate }}
            </button>
            <button mat-menu-item (click)="OpenPrePartnerSheetPopUp(element);GetPartnersMasterData();">
              <i class="material-icons menuitemIcon">file_copy</i>
              {{ 'ViewPartnerSheet' | translate }}
            </button>
            <button mat-menu-item (click)="element.IsSelected = true; OpenCombinePartners();">
              <i class="material-icons menuitemIcon">keyboard_double_arrow_right</i>
              {{ 'CombinePartners' | translate }}
            </button>
            <button mat-menu-item (click)="GeneratePartnerNotificationEmailSubjectAndBody(element.ID);">
              <i class="material-icons menuitemIcon">attach_email</i>
              {{ 'NotifyClientOfOverDueInvoices' | translate }}
            </button>
            <button mat-menu-item (click)="GetAutomatedTasksConnections(element.ID);">
              <i class="material-icons menuitemIcon">motion_photos_auto</i>
              {{ 'GetAutomatedTasks' | translate }}
            </button>
            <button mat-menu-item (click)="OpenStockFormatContainer(element);">
              <i class="material-icons menuitemIcon">file_open</i>
              {{ 'PrefferedStockFormat' | translate }}
            </button>
            <button mat-menu-item (click)="DeletePartner(element);">
              <i class="material-icons menuitemIcon">close</i>
              {{ 'Partners.Delete' | translate }}
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsPartners; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPartners;"></tr>
    </table>
  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageIndex]="pageIndex"
    (page)="PageEvent = getPageEvent($event);">
  </mat-paginator>

</div>